import BSInfantFruitsAndVegsProduct from 'models/BSInfantFruitsAndVegsProduct'
import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import BSInfantFruitsAndVegsPackage from './BSInfantFruitsAndVegsPackage'
import BSInfantNotice from '../BSInfantNotice'

const productOptions = {
  notice: <BSInfantNotice name="Infant Fruits and Vegetables" />,
  packagingInfo: <BSInfantFruitsAndVegsPackage />,
  productTitle: 'Brand Specific Infant Fruits and Vegetables',
  model: BSInfantFruitsAndVegsProduct,
  validCategories: ['12'],
  validSubCategories: ['001BS', '002BS', '003BS', '101BS', '102BS', '103BS'],
  brandSpecific: true,
}

const BSInfantFruitsAndVegs = () => <ProductForm product={productOptions} />

export default BSInfantFruitsAndVegs
